import { api, client } from "@/client";
import { log } from "console";
import { defineStore, acceptHMRUpdate } from "pinia";

export const useAgencyStore = defineStore("agency", {
  state: () => ({
    loading: false,
    currentAgency: {} as any,
    orginalAgency: {},
    afterProcessAgency: [] as any,
    totalcount: 0 as number,
    // childAgency: [{}] as Array<any>,
    ChildAgencyName: {},
    ChildAgencyId: "Hello" as string,
    abc: "" as string,
    proxyAgency: [] as any,
    proxyAgencyEdit: [] as any,
    containsError: false,
    toggleModal: false,
    targetModal: "",
    errorModalVisible: false,
    errorEditModalVisible: false,
    currentPage: 1,
    currentPerPage: 20,
    currentAgencyUuid: 0,
    currentAgencyId: 0,
    editAgencyIndex: 0,
    reloadTable: false,
    addNewAgencyModalVisible: false,
    editAgencyModalVisible: false,
    newAgency: [] as any,
    closeEditErrorModal: false,
  }),
  getters: {},
  actions: {
    async fetchAgencyList() {
      this.loading = true;
      client.agency.agencyList({})
        .then((payload) => {
          this.loading = false;

          this.afterProcessAgency = payload;

          for (let index = 0; index < payload.length; index++) {
            this.afterProcessAgency[index].number = index;
            if(this.currentAgencyUuid !=0 && this.currentAgencyUuid === this.afterProcessAgency[index].uuid){    
             
              this.editAgencyIndex = index;
            }
            if (payload[index].proxyId == null && payload[index].proxyName == null) {
              this.afterProcessAgency[index].hasProxy = false;
              for (let i = 0; i < this.afterProcessAgency.length; i++) {
                if (this.afterProcessAgency[i].proxyName === payload[index].name && this.afterProcessAgency[i].proxyId === payload[index].id) {
                  // throw new Error("Something went badly wrong!");                      
                  const childAgency = { "childAgencyname": this.afterProcessAgency[i].name, "childAgencyId": this.afterProcessAgency[i].id, "childUuid": this.afterProcessAgency[i].uuid, "childStatus": this.afterProcessAgency[i].active };
                  // Check if childAgency array exists, if not create it
                  if (!this.afterProcessAgency[index].childAgency) {
                    this.afterProcessAgency[index].childAgency = [];
                  }
                  this.afterProcessAgency[index].childAgency.push(childAgency);
                }
              }

              if (this.afterProcessAgency[index].childAgency == null) {
                this.afterProcessAgency[index].isProxy = false;

              } else {
                this.afterProcessAgency[index].isProxy = true;
              }

            } else {
              this.afterProcessAgency[index].hasProxy = true;
              this.afterProcessAgency[index].isProxy = false;
            }

          }
          if(this.currentAgencyUuid == 0) {
            this.currentAgency = this.afterProcessAgency[payload.length-1];
            this.currentAgencyUuid = this.currentAgency.uuid;
            
           }else{
            this.currentAgency = this.afterProcessAgency[this.editAgencyIndex];
            this.currentAgencyUuid = this.currentAgency.uuid;
         
           }
        

        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          //this.loading = false;
          return error;
        });
    },
    fetchAgency(row: any) {
      this.$reset;
      this.currentAgency = row;
      this.currentAgencyUuid = row.uuid;
    },
    async fetchProxyAgency() {
      // reset the proxy Agency when refresh 
      this.proxyAgency = [];
      for (let index = 0; index < this.afterProcessAgency.length; index++) {
        if (this.afterProcessAgency[index].hasProxy == false && this.afterProcessAgency[index].active == true) {
          const proxyList = { "proxyId": this.afterProcessAgency[index].id, "proxyName": this.afterProcessAgency[index].name };
          this.proxyAgency.push(proxyList);
        }
      }
    },
    async fetchProxyAgencyEditVersion(OnlickAgencyId) {
      // reset the proxy Agency when refresh 
      this.proxyAgencyEdit = [];
     
      for (let index = 0; index < this.afterProcessAgency.length; index++) {
        if (this.afterProcessAgency[index].hasProxy == false  && this.afterProcessAgency[index].active == true && this.afterProcessAgency[index].id !=OnlickAgencyId  ) {
          const proxyList = { "proxyId": this.afterProcessAgency[index].id, "proxyName": this.afterProcessAgency[index].name };
          this.proxyAgencyEdit.push(proxyList);
        }
      }
    },
    //fetchAgencyDetail is direct connect API detail but SDPS never use
    async fetchAgencyDetail() {
      this.loading = true;
      client.agency.agencyRead({
        uuid: "123123123",
      })
        .then((payload) => {
          this.currentAgency = payload;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          //this.loading = false;
          return error;
        });
    },

    async addAgency(newAgency: any) {
      this.loading = true;
      this.errorModalVisible = false;
      client.agency.agencyCreate({
        createRequestBody: newAgency
      })
        .then((payload) => {
          this.currentAgencyUuid = 0;
          this.reloadTable = true;
          this.fetchAgencyList();
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.reloadTable = false;
        })
        .catch((error) => {
          this.errorModalVisible = true;
          this.addNewAgencyModalVisible = false;
          this.newAgency = newAgency;
          this.loading = false;
          return error;
        });
    },
    async updateAgency(uuid: string, newAgency: any) {
      this.loading = true;
      this.errorEditModalVisible = false;
      this.closeEditErrorModal = false;
      client.agency.agencyUpdate({
        uuid: uuid,
        updateRequestBody: newAgency
      })
        .then((payload) => {
          this.fetchAgencyList();
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.errorEditModalVisible = true;
          this.editAgencyModalVisible = false;
        });
    },
    
    storeCurrent(currentPage, currentPerPage) {
      this.currentPage = currentPage;
      this.currentPerPage = currentPerPage;
    },
    updateUuid(uuid){
      this.currentAgencyUuid = uuid;
      this.fetchAgencyList();
    },
    openAddNewModal(){
      this.addNewAgencyModalVisible = true;
    },
    closeAddNewModal() {
      this.addNewAgencyModalVisible = false;
    },
    openEditModal(){
      this.editAgencyModalVisible = true;
    },
    closeEditModal() {
      this.editAgencyModalVisible = false;
    },
    closeErrorModal() {
      this.errorModalVisible = false;
    },
    closeErrorEditModal() {
      this.closeEditErrorModal = true;
    }
  }
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAgencyStore, import.meta.hot));
}